const ROUTE_PATHS = {
  HOME: "/",
  WSM_SIGNIN: "/sign-in",
  WSM_INITIAL_LOAD: "/loading",
  WSM_PROFILE_SETUP: "/profile-setup",
  WSM_PROFILE_SETUP_DETAIL: "/profile-setup-detail",
  WSM_PROFILE_SETUP_FOUNDER: "/profile-setup-founder",
  WSM_PROFILE_SETUP_NOT_FOUNDER: "/profile-setup-not-founder",
  WSM_FAQ: "/faq",
  WSM_KEYS: "/keys",
  WSM_HOME: "/home",
  WSM_CALENDAR: "/calendar",
  WSM_WORKSPACE_DETAIL: "/calendar/workspace-detail/:slotId",
  WSM_RETREAT_DETAIL: "/calendar/retreat-detail/:slotId",
  WSM_EXPERIENCE_PASSES: "/slots/:type",
  WSM_MEETING_ROOM_LIST: "/calendar/meeting-rooms",
  WSM_CALENDAR_SUCCESS: "/calendar/success",
  WSM_CALENDAR_PAYMENT: "/calendar/payment",
  WSM_CALENDAR_DF_WORKSPACE_DETAIL: "/calendar/df-workspace",
  WSM_CALENDAR_INNOVATIVE_SPACE: "/calendar/innovative-space",
  WSM_CALENDAR_CREATIVE_SPACE: "/calendar/creative-space",
  WSM_CALENDAR_EVENT_DETAIL: "/calendar/event",
  WSM_CALENDAR_MB_STUDIO_DETAIL: "/calendar/mb-studio",
  WSM_CALENDAR_COMMUNICATE_SPACE_DETAIL: "/calendar/communicate-space",
  WSM_CALENDAR_THE_FOUNDRY_DETAIL: "/calendar/the-foundry",
  WSM_CALENDAR_SCALING_WORKSHOPS_DETAIL: "/calendar/scaling-workshops",
  WSM_MEMBERSHIP_PLAN_DETAIL: "/membership/plan-membership",
  WSM_UR_MEMBERSHIP_PLAN_DETAIL: "/membership/ur-membership-plan",
  WSM_MEMBERSHIP_PAYMENT_DETAIL: "/membership/payment",
  WSM_MEMBERSHIP_CREDIT_PLAN_DETAIL: "/membership/credit-plan",
  WSM_MEMBERSHIP_ONE_DAY_PASS_DETAIL: "/membership/one-day-pass",
  WSM_MEMBERSHIP_PASS_DETAIL: "/membership/pass",
  WSM_MEMBERSHIP_PASSES: "/membership/passes",
  WSM_PAYMENT_SUCCESS: "/payment-success/:invoiceId",
  WSM_RESERVATION_CANCEL: "/reservation/cancel",
  WSM_PAYMENT_HISTORY: "/payment-history",
  WSM_PAYMENT_HISTORY_DETAIL: "/payment-history/detail",
  WSM_ALL_SET: "/all-set",
  WSM_CALENDAR_PASS_SUCCESS_SCREEN: "/calendar/all-set",
  WSM_CALENDAR_PASS_THANK_YOU_SCREEN: "/calendar/all-set/thanks",
  WSM_CALENDAR_PASS_LAST_STAGE_THANK_YOU_SCREEN: "/calendar/all-set/thanks/stage/4",
  WSM_CALENDAR_PASS_WELCOME_SCREEN: "/calendar/pass/welcome",
  WSM_CALENDAR_PASS_INTRODUCTION_SCREEN: "/calendar/pass/introduction/:stage",
  WSM_CALENDAR_PASS_QUESTION_SCREEN: "/calendar/all-set/pass",
  WSM_WEB_LINK_DETAIL: "/web-link",
  WSM_SCORE_CARD_INITIAL_SCREEN: "/score-card/initial",
  WSM_SCORE_CARD_MATTERS_SCREEN: "/score-card/matters",
  WSM_SCORE_CARD_QUESTION_SCREEN: "/score-card/question",
  WSM_SCORE_CARD_READINESS_SCREEN: "/score-card/readiness",
  WSM_SCORE_CARD_RESULT_SCREEN: "/score-card/result",
  WSM_SCRATCH_CARD_SCREEN: "/score-card/scratch",
  WSM_SETTINGS_SCREEN: "/profile/settings",
  WSM_SLOTS_LOGIN_SCREEN: "/login",
  WSM_SLOTS_PAYMENT_SCREEN: "/payment"
};

export default ROUTE_PATHS;
